import { render, staticRenderFns } from "./videoEmbedBlock.vue?vue&type=template&id=64b3203f&scoped=true"
import script from "./videoEmbedBlock.vue?vue&type=script&lang=js"
export * from "./videoEmbedBlock.vue?vue&type=script&lang=js"
import style0 from "./videoEmbedBlock.vue?vue&type=style&index=0&id=64b3203f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3203f",
  null
  
)

export default component.exports